import { setContext } from '@apollo/client/link/context';
import { HttpLink, concat } from '@apollo/client';

type Args = {
  appSyncApiUrl: string;
  getJWTToken: () => Promise<string | undefined>;
};
const createHttpLink = function ({ appSyncApiUrl, getJWTToken }: Args) {
  const authorizationHeaderLink = setContext(async (_, previousContext) => ({
    ...previousContext,
    headers: {
      Authorization: await getJWTToken(),
    },
  }));

  return concat(authorizationHeaderLink, new HttpLink({ uri: appSyncApiUrl }));
};

export default createHttpLink;
